var map = {
	"./remark_01.svg": "25f3",
	"./remark_02.svg": "f5c2",
	"./remark_03.svg": "ff88",
	"./remark_04.svg": "0649",
	"./remark_05.svg": "fcfa",
	"./remark_06.svg": "6997",
	"./remark_07.svg": "4180",
	"./remark_08.svg": "10d7",
	"./remark_09.svg": "cbcd",
	"./remark_10.svg": "a3c0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3197";